import dayjs from 'dayjs';

/**
 * @author Dat Doan
 * @date 2021-03-01
 * @desc
 *  Key code constants
 */
export const keyCode = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
};

/**
 * @author Dat Doan
 * @date 2021-03-01
 * @param {string} locationSearch
 * @param {string} name
 * @returns {string}
 */
export function getUrlParameter(locationSearch, name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(locationSearch);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * @author Dat Doan
 * @date 2021-03-05
 * @param {string} url
 * @param {string} parameter
 * @returns {string}
 */
export function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0; ) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

/**
 * @author Dat Doan
 * @date 2021-03-05
 * @param {string} locationSearch
 * @param {string} queryStrings
 * @returns {string}
 */
export function clearURLQueryStrings(locationSearch, queryStrings) {
  let urlString = locationSearch;
  queryStrings.forEach((type) => {
    urlString = removeURLParameter(urlString, type);
  });
  return urlString;
}

/**
 * @author Dat Doan
 * @date 2021-03-05
 * @param {string} label
 * @returns {string}
 */
export function upperCaseFirstLetter(label) {
  return label.replace(/^\w/, (c) => c.toUpperCase());
}

/**
 * @author Dat Doan
 * @date 2021-03-24
 * @param {string} dateFrom
 * @param {string} dateTo
 * @returns {number} number of night
 */
export function getNumberOfNight(dateFrom, dateTo) {
  return dayjs(dateTo, 'DD/MM/YYYY').diff(dayjs(dateFrom, 'DD/MM/YYYY'), 'day');
}

/**
 * Delay execution
 * @param {number} ms
 */
export function sleep(ms) {
  return new Promise((fulfil) => {
    setTimeout(fulfil, ms);
  });
}

/**
 * Return a number from string
 * @param {string} string
 */
export function returnNumberOrZero(string) {
  return isNaN(Number(string)) ? 0 : Number(string);
}
